import React from 'react';
import { Modal } from '../../components';
import css from './ShoeSizeChartModal.module.css';

const UNIVERSAL_SHOE_SIZES = [
  { usM: '4', usW: '5.5', eu: '36', uk: '3.5', cm: '22.5 cm' },
  { usM: '4.5', usW: '6', eu: '37', uk: '4', cm: '23.0 cm' },
  { usM: '5', usW: '6.5', eu: '37.5', uk: '4.5', cm: '23.5 cm' },
  { usM: '5.5', usW: '7', eu: '38', uk: '5', cm: '24.0 cm' },
  { usM: '6', usW: '7.5', eu: '38.5', uk: '5.5', cm: '24.5 cm' },
  { usM: '6.5', usW: '8', eu: '39', uk: '6', cm: '25.0 cm' },
  { usM: '7', usW: '8.5', eu: '40', uk: '6.5', cm: '25.5 cm' },
  { usM: '7.5', usW: '9', eu: '40.5', uk: '7', cm: '26.0 cm' },
  { usM: '8', usW: '9.5', eu: '41', uk: '7.5', cm: '26.5 cm' },
  { usM: '8.5', usW: '10', eu: '41.5', uk: '8', cm: '27.0 cm' },
  { usM: '9', usW: '10.5', eu: '42.5', uk: '8.5', cm: '27.5 cm' },
  { usM: '9.5', usW: '11', eu: '43', uk: '9', cm: '28.0 cm' },
  { usM: '10', usW: '11.5', eu: '44', uk: '9.5', cm: '28.5 cm' },
  { usM: '10.5', usW: '12', eu: '44.5', uk: '10', cm: '29.0 cm' },
  { usM: '11', usW: '12.5', eu: '45', uk: '10.5', cm: '29.5 cm' },
  { usM: '11.5', usW: '13', eu: '45.5', uk: '11', cm: '30.0 cm' },
  { usM: '12', usW: '13.5', eu: '46', uk: '11.5', cm: '30.5 cm' },
  { usM: '13', usW: '14.5', eu: '47.5', uk: '12.5', cm: '31.5 cm' },
  { usM: '14', usW: '15.5', eu: '48.5', uk: '13.5', cm: '32.5 cm' },
];

const ShoeSizeChartModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      id="ShoeSizeChartModal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={() => {}}
      containerClassName={css.modalContainer}
      closeButtonMessage="Close"
      usePortal
    >
      <div className={css.root}>
        <button className={css.closeButton} onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 className={css.title}>SHOE SIZE CONVERSION CHART</h2>
        <div className={css.tableWrapper}>
          <table className={css.sizeTable}>
            <thead>
              <tr className={css.headerRow}>
                <th className={css.standardHeader} colSpan="5">STANDARD SIZES</th>
              </tr>
              <tr className={css.columnHeaders}>
                <th>US Men</th>
                <th>US Women</th>
                <th>EU</th>
                <th>UK</th>
                <th>Foot Length</th>
              </tr>
            </thead>
            <tbody>
              {UNIVERSAL_SHOE_SIZES.map((size, index) => (
                <tr key={index} className={css.sizeRow}>
                  <td>{size.usM}</td>
                  <td>{size.usW}</td>
                  <td>{size.eu}</td>
                  <td>{size.uk}</td>
                  <td>{size.cm}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={css.note}>
          <p>
            <em>
              This is a general size conversion guide. Sizing may vary slightly depending on the brand, style, and manufacturer.
            </em>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ShoeSizeChartModal;


